import React, { memo, useEffect, useState } from "react";

const Listv3 = memo((props) => {
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(3);
  const [isHide, setIsHide] = useState(false);

  const showMoreItems = async () => {
    if (visible <= props.event.length) {
      setVisible(visible + 3);
    }
  };

  useEffect(() => {
    setItems(props.event);
    if (visible >= props.event.length) {
      setIsHide(true);
    }
    // eslint-disable-next-line
  }, [visible]);

  return (
    <>
      <div className="event-list-row grid grid-cols-3 gap-20">
        {items.slice(0, visible).map((item, index) => (
          <div
            key={index}
            className="mb-10 grid row-span-3"
          >
            <div className="potrait-event-container text-white">
              {item.link ? (
                <div className="image-container">
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <img className="rounded-2xl" src={item.photo} alt="lamp_tree" />
                  </a>
                </div>
              ) : (
                <div className="image-container">
                  <img className="rounded-2xl" src={item.photo} alt="lamp_tree" />
                </div>
              )}
              <div className="">
                <h4 className="mb-3">{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mb-10">
        <button
          onClick={showMoreItems}
          className={`text-white text-black  py-2 px-4 btn-rsvp mb-10 border border-white ${
            isHide ? "hidden" : ""
          }`}
        >
          VIEW MORE
        </button>
      </div>
    </>
  );
});

export default Listv3;
